module.exports = __webpack_public_path__ + "img/banner_3.36d0fb53.png";